import api from './api';

const integrationService = {
  // Connect to an external system
  connectToExternalSystem: async (projectId, integrationType, configuration) => {
    try {
      const response = await api.post(`/integrations/projects/${projectId}/connect`, {
        integrationType,
        configuration
      });
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to connect to external system';
    }
  },

  // Get all integrations for a project
  getProjectIntegrations: async (projectId) => {
    try {
      const response = await api.get(`/integrations/projects/${projectId}`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch integrations';
    }
  },

  // Sync features with external system
  syncFeatures: async (integrationId, features) => {
    try {
      const response = await api.post(`/integrations/${integrationId}/sync-features`, {
        features
      });
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to sync features';
    }
  },

  // Sync user stories with external system
  syncUserStories: async (integrationId, featureId, userStories) => {
    try {
      const response = await api.post(`/integrations/${integrationId}/features/${featureId}/sync-stories`, {
        userStories
      });
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to sync user stories';
    }
  },

  // Disconnect from an external system
  disconnectExternalSystem: async (integrationId) => {
    try {
      await api.delete(`/integrations/${integrationId}`);
      return true;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to disconnect from external system';
    }
  }
};

export default integrationService;